import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.578 3.473c.551.55 1.333.693 2.026.426l4.052 4.087c.302.302.8.302 1.102 0a.783.783 0 0 0 0-1.101l-4.07-4.088A1.955 1.955 0 0 0 3.262.771a1.916 1.916 0 0 0-2.133-.39l1.262 1.261-.942.942L.188 1.322c-.32.711-.196 1.582.39 2.15Z",
  fill: "#F9F7FA"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }